import CacheRequest from 'qs-data/cacheRequest';
import CacheKeys from 'qs-data/cacheKeys';

export const updateCustomVariantCache = (data) => {
  CacheRequest.setCacheForKey(CacheKeys.customVariant, data);
};
